/**
 * Context-aware landing — wire types shared between the API and the visitor PWA.
 *
 * Spec: docs/strategy/context-aware-landing-plan-2026-05-15.md
 * Endpoint: GET /api/protocol/landing?qrCode=X&lang=Y  (anonymous, rate-limited)
 *
 * The same JSON shape is consumed by:
 *   - the visitor PWA's FeedbackPage (parallel fetch + swap-on-arrival)
 *   - AI agents calling via MCP (P8: ?as=agent variant)
 *
 * A fallback response is the same shape with `cacheKey === 'fallback'`,
 * `ttlSec === 0`, and an empty `citations[]`. Visitor PWA renders either
 * shape identically — no discriminator needed.
 */
export const LANDING_FALLBACK_CACHE_KEY = 'fallback';
export const LANDING_PROTOCOL_ENDPOINT = '/api/protocol/landing';
export const VISITOR_SESSION_HEADER = 'X-Visitor-Session';
export const VISITOR_SESSION_STORAGE_KEY = 'tl_visitor_session_v1';
/** Sliding window for the visitor session. Each scan extends to `now + this`. */
export const VISITOR_SESSION_TTL_MS = 4 * 60 * 60 * 1000;
/** Late-arrival discard threshold on the client (ms after page-load). */
export const LANDING_LATE_ARRIVAL_MS = 3500;
/** Client fetch budget (ms). Slightly higher than server budget so the server's own fallback path reaches us. */
export const LANDING_CLIENT_TIMEOUT_MS = 4000;
/** Server hard timeout for the Haiku call (ms). On timeout the server returns a fallback shape. */
export const LANDING_SERVER_TIMEOUT_MS = 3000;
/** Cache TTL (seconds). */
export const LANDING_CACHE_TTL_SEC = 600;
/** Stale-while-revalidate threshold (seconds). Serve stale + refresh in bg above this age. */
export const LANDING_STALE_THRESHOLD_SEC = 300;
/** Foresight cluster threshold — N visitors asking similar questions in the window. */
export const FORESIGHT_MIN_CLUSTER = 5;
/** Foresight cluster window (minutes). */
export const FORESIGHT_CLUSTER_WINDOW_MIN = 60;
/** Same-session repeat suppression for the same anticipated answer (hours). */
export const FORESIGHT_REPEAT_SUPPRESSION_HOURS = 4;
//# sourceMappingURL=landing-types.js.map